var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopbite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.6,132c-5.1-4.4-5.1-4.5-11.5-1c-2.8,1.5-5.5,3.2-8,5c-3.3,2.4-5.6,5.5-4.5,10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.6,150.5c-1.7,2.6,1.3,3.3,2.1,5c2.3,5.2,5.3,10,5,16c-0.1,3.7-1.9,5-5.1,5c-4.8,0-9.5,0.4-14-1.9 c-1.9-1-4.2-1.6-6.5-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,150.5c1.7,2.6-1.3,3.3-2.1,5c-2.3,5.2-5.3,10-5,16c0.1,3.7,1.9,5,5.1,5c4.8,0,9.5,0.4,14-1.9 c1.9-1,4.2-1.6,6.5-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.6,122c2-3.1,4.5-5.4,8.5-4.5c6,1.4,12.2,1.8,18,3.9c2.4,0.9,5.7,1.3,6.3,3.6c0.8,3.5,1.7,8.2-1,10.7 c-2.9,2.8-4.2,6.2-6.2,9.2c-2.4,3.6-5.4,6.7-8.6,9.4c-4.4,3.7-7.9,2.9-10.9-1.9c-1.9-2.9-2.9-6.2-4.2-9.4c-1.2-3.1-1-6.1-1.8-9.1 C213.6,134,211.7,128.7,213.6,122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.1,137c1.5,3.3-0.9,6.1-1.7,8.9c-1.2,4.3-0.7,8.4-0.7,12.6c0,3.3,3.3,5.3,6.4,3.9c3.7-1.6,7.6-3,10.5-5.9 c3.1-3.1,6.4-5.9,9.9-8.6c4.5-3.4,8.8-4.2,14.1-2c4.9,2,9.6,3.4,10.1,10.1c0.3,4.9,2.1,9.7-1.6,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.6,227.5c-3.6,3.5-8.8,5.6-9.6,11.5c-0.2,1.6-0.7,3,0.1,4.5c2,3.8,2.7,8,3.4,12c1.5,8.7,6,9.4,12.1,10.8 c2.8,0.6,5.9,1.3,9,0.2c5-1.7,10,0.2,15,0.1c4.4-0.1,5.6,1.7,7,8.9c1.4,7.3,2.8,14.6,4,22c0.5,3.3-2.3,4.7-4.5,5.9 c-8.1,4.7-17.1,4.9-25.9,3.8c-5.2-0.6-8.8-5.1-9.3-10.3c-0.4-4.3-1.3-8.3-2.1-12.5c-1.4-7.8,3.1-11.7,9.9-14.9 c0.7-0.3,1.4-0.5,2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.6,196c-6.9-0.6-12,2.5-14.9,8.5c-2.3,4.9-2,13,4.4,16.5c0.7,0.4,1,1.3,1.5,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.6,227.5c3.5,3.4,8.4,5.4,9.6,11c0.4,1.8,0.8,3.4-0.1,5c-2,3.8-2.7,8-3.4,12c-1.5,8.7-6,9.4-12.1,10.8 c-2.8,0.6-5.9,1.3-9,0.2c-5-1.7-10,0.2-15,0.1c-4.4-0.1-5.6,1.7-7,8.9c-1.4,7.3-2.8,14.6-4,22c-0.5,3.3,2.3,4.7,4.5,5.9 c8.1,4.7,17.1,4.9,25.9,3.8c5.2-0.6,8.8-5.1,9.3-10.3c0.4-4.3,1.3-8.3,2.1-12.5c1.4-7.8-3.1-11.7-9.9-14.9c-0.7-0.3-1.4-0.5-2-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.6,146c1-4.5-1.2-7.5-4.5-10c-2.5-1.9-5.2-3.5-8-5c-6.4-3.5-6.4-3.4-11.5,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.1,202c0.2,2.2-2,2.1-3,2.9c-4.2,3.2-6.9,9.5-5.5,13.6c1.5,4.3,7,7.6,12,8.1c4.4,0.5,8.6-0.2,12.5-1.8 c5.3-2.2,10.4-1.2,15.6-0.4c2,0.3,2.4,1.6,3.1,3.5c3,8.3,4.7,17,6.8,25.6c1,4-1.1,6.3-6.9,9c-1.6,0.8-3.6,0.6-5,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.6,122c-2-3.1-4.5-5.4-8.5-4.5c-6,1.4-12.1,1.9-18,3.9c-6,2-9.6,9.9-5.3,14.4c2.7,2.8,4.2,6.1,6.3,9.2 c2.4,3.6,5.4,6.7,8.6,9.4c4.4,3.7,7.9,2.9,10.9-1.9c1.9-2.9,2.9-6.2,4.2-9.4c1.2-3.1,1.4-6.1,1.8-9.1 C211.6,134,213.2,126.6,211.6,122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.6,196c6.9-0.6,12,2.5,14.9,8.5c2.3,4.9,2,13-4.4,16.5c-0.7,0.4-1,1.3-1.5,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.1,174c-1.7,3.4-5.3,4.4-8.1,6.4c-4.2,3-7.1,9.3-4.4,15.1c2.7,5.8,7.4,7,14.5,6.2c5-0.5,9.2-2.1,13.5-4.3 c7.4-3.8,11.5-10.6,6.9-19.4c-3.4-6.6-11.9-11-20.9-5.1c-0.3,0.2-0.7,0.3-1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,202c0.2,2.5,2.6,2.4,4,3.5c3.3,2.6,5.7,9.4,4.5,13c-1.4,4.2-6.9,7.6-11.5,8.1 c-5.1,0.6-9.9-0.6-14.5-2.2c-5-1.8-9.7-0.5-14.5,0.2c-2.6,0.4-2.9,3.1-3.4,5c-2.2,7.6-4.2,15.3-6,23c-0.7,2.9-0.7,5.9,2.9,7.5 c3.1,1.4,6,3,9,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.1,137c-1.5,3.3,0.9,6.1,1.7,8.9c1.2,4.3,0.7,8.4,0.7,12.6c0,3.3-3.3,5.3-6.3,3.9 c-4.1-1.9-8.6-3.3-11.5-6.9c-2.8-3.5-6.8-5.6-10.1-8.4c-5.4-4.6-10.8-1.7-16.5,0.2c-4.7,1.6-5.6,4.8-6.5,8.7 c-1.3,5.7-2.2,11.6,3.2,15.3c4,2.7,7.1,6.5,11.4,8.6c6.3,3.2,7.7,10.9,5.5,15.5c-2.8,5.7-7.1,7.1-15,6.1c-7-0.9-13.1-3-18-8.1 c-4-4.2-4.7-8.3-2-14.5c2.2-5,5.6-8.4,11.5-8.5c1.7,0,3.3,0,5,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbite);
export default __webpack_public_path__ + "static/media/Topbite.13c654b52a48f7390604fefe791523d1.svg";
export { ForwardRef as ReactComponent };